export default "__VITE_ASSET__3eedb7da__"